import RouteError from '@/components/ui/route-error';
import { createFileRoute } from '@tanstack/react-router';
import DashboardRouteLayout from '@/app/components/dashboard-route-layout';
import DashboardPageShell from '@/app/components/dashboard-page-shell';
import { DICTIONARY } from '@/config/dictionary';
import { requireAuth } from '@/utils/require-auth-before-load';
import { queryClient } from '@/lib/query-client';
import RolesAdminTab from '@/features/admin-settings/components/roles-admin-tab';
import { getRolesQueryOptions } from '@/features/admin-settings/api/rbac-api';

const d = DICTIONARY.adminSettingsPage.rolesAdmin;

const RolesAdminPage = () => (
  <DashboardRouteLayout>
    <DashboardPageShell title={d.pageTitle} description={d.pageDescription}>
      <RolesAdminTab />
    </DashboardPageShell>
  </DashboardRouteLayout>
);

export const Route = createFileRoute('/admin-settings/roles-admin')({
  beforeLoad: requireAuth,
  loader: async () => {
    await queryClient.prefetchQuery(getRolesQueryOptions());
    return null;
  },
  component: RolesAdminPage,
  errorComponent: RouteError,
});
